import { render } from "./TheSideMenu.vue?vue&type=template&id=2ac8bfea"
import script from "./TheSideMenu.vue?vue&type=script&lang=js"
export * from "./TheSideMenu.vue?vue&type=script&lang=js"

import "./TheSideMenu.vue?vue&type=style&index=0&id=2ac8bfea&lang=css"

import exportComponent from "F:\\Softwaresul\\Projetos\\LWP\\Nil Recruiter\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__